var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12 15-4.242-4.242 1.414-1.414 2.829 2.828 2.828-2.828 1.414 1.414z"
})));
export { SvgArrowDownSmall as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMi4wMDA1IDE1LjAwMDZMNy43NTc4MSAxMC43NThMOS4xNzIwMyA5LjM0Mzc1TDEyLjAwMDUgMTIuMTcyMkwxNC44Mjg5IDkuMzQzNzVMMTYuMjQzMSAxMC43NThMMTIuMDAwNSAxNS4wMDA2WiIgZmlsbD0id2hpdGUiLz4NCjwvc3ZnPg0K";